import React from 'react';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import HvacOutlinedIcon from '@mui/icons-material/HvacOutlined';
import trustItems from '../../data/trustItems';

const trustIcons = [
  <PlaceOutlinedIcon fontSize="small" />,
  <BoltOutlinedIcon fontSize="small" />,
  <TaskAltOutlinedIcon fontSize="small" />,
  <HvacOutlinedIcon fontSize="small" />,
];

const TrustBar = () => (
  <section className="trust-bar">
    <div className="container trust-bar-grid">
      {trustItems.map((item, index) => (
        <div key={item.label} className="trust-item">
          <span className="trust-item-icon" aria-hidden="true">
            {trustIcons[index]}
          </span>
          {item.href ? (
            <a href={item.href} target="_blank" rel="noopener noreferrer">
              {item.label}
            </a>
          ) : (
            <span>{item.label}</span>
          )}
        </div>
      ))}
    </div>
  </section>
);

export default TrustBar;
